import { Box } from '@mui/material';
import React from 'react';

const UnauthorizedPage: React.FC = () => {
    return (
        <Box sx={{ padding: 4 }}>
            <h1>ບໍ່ມີສີດເຂົ້າເຖິງ</h1>
            <p>ທີ່ບໍ່ໄດ້ຮັບອະນຸຍາດໃຫ້ເບິ່ງໜ້ານິ້.</p>
        </Box>
    );
};

export default UnauthorizedPage;